import React from 'react';
interface IconProps {
  width?: number;
  height?: number;
}

const HomeValueIconVrijstaandeWoning = (props: IconProps) => {
  return (
    <svg width={33} height={52} fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M1.112 13.89L16.668 1.445 32.223 13.89M1.112 16.223V52h31.111V16.223"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.334 51.224V31.779H6.557v19.445"
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        stroke="currentColor"
        strokeWidth={1.5}
        strokeLinejoin="round"
        d="M6.557 18.557h7.778v7.778H6.557zM19.778 31.779h7.778v7.778h-7.778zM19.778 18.557h7.778v7.778h-7.778z"
      />
    </svg>
  );
};

export default HomeValueIconVrijstaandeWoning;
